import { render, staticRenderFns } from "./EditEmergencyContactNumber.vue?vue&type=template&id=7ad3fae9&scoped=true&"
import script from "./EditEmergencyContactNumber.vue?vue&type=script&lang=js&"
export * from "./EditEmergencyContactNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad3fae9",
  null
  
)

export default component.exports